import {useTranslation} from "react-i18next";
import img_banner from "../assets/image/contact/img_dialog.webp";
import {Dialog, DialogBackdrop, DialogPanel} from "@headlessui/react";

function SubmitSuccessDialog(props) {
    const {t} = useTranslation();
    return (
        <Dialog open={props.open} onClose={props.onClose} className="relative z-50">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-black/50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full justify-center p-4 text-center items-center">
                    <DialogPanel transition
                                 className="relative transform overflow-hidden w-full max-w-lg max-h-full text-black">
                        <div className="bg-white rounded-xl shadow flex flex-col gap-y-2">
                            <img src={img_banner} alt="Dialog banner" className="rounded-t-xl"/>
                            <div className="py-6">
                                <div className="text-2xl font-bold mb-0.5">{t("send_message_dialog_title")}</div>
                                <div className="text-base mb-6">{t("send_message_dialog_subtitle")}</div>
                                <>
                                    <button type="button"
                                            onClick={props.onClose}
                                            className="py-2.5 px-5 text-2xl font-bold text-white bg-primary rounded">
                                        {t("send_message_dialog_button")}
                                    </button>
                                </>
                            </div>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    )
}

export default SubmitSuccessDialog;